import React from "react";

const RSS = props => (
  <svg viewBox="0 0 18.96 18.96" {...props}>
    <title>RSS Icon</title>
    <g>
      <path
        d="M0 16.35A2.6 2.6 0 1 1 2.6 19 2.6 2.6 0 0 1 0 16.35zM0 6.5v3.38A9.09 9.09 0 0 1 9.08 19h3.38A12.47 12.47 0 0 0 0 6.5zM0 0v3.38A15.6 15.6 0 0 1 15.58 19H19A19 19 0 0 0 0 0z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default RSS;



// WEBPACK FOOTER //
// ./src/icons/RSS.js